import React, { useState } from 'react';
import { Container, Typography, Box, TextField, Button, Paper, Grid, useTheme, useMediaQuery } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useLanguageContext } from '../context/LanguageContext';
import { translations } from '../translations';

function Contact() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { language } = useLanguageContext();
  const t = translations[language];
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you can add your form submission logic
    console.log('Form submitted:', formData);
    // For demo purposes, we'll just show a success message
    setStatus({ 
      type: 'success', 
      message: t.contact.form.success 
    });
    // Reset form
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Box sx={{ mb: 6, textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom>
          {t.contact.title}
        </Typography>
        <Typography variant="h6" color="text.secondary">
          {t.contact.subtitle}
        </Typography>
      </Box>

      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12} md={8} lg={6}>
          <Paper elevation={3} sx={{ p: 4, height: '100%' }}>
            <Typography variant="h5" component="h2" gutterBottom color="primary" textAlign='center'>
              {t.contact.info.title}
            </Typography>
            
            <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
              <EmailIcon 
                color="primary" 
                sx={{ 
                  fontSize: { xs: '1.2rem', sm: '1.4rem' },
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'rotate(10deg) scale(1.1)',
                  },
                }} 
              />
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  {t.contact.info.email}
                </Typography>
                <Typography variant="body1">
                  {t.personalInfo.contact.email}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
              <PhoneIcon 
                color="primary" 
                sx={{ 
                  fontSize: { xs: '1.2rem', sm: '1.4rem' },
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'rotate(10deg) scale(1.1)',
                  },
                }} 
              />
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  {t.contact.info.phone}
                </Typography>
                <Typography variant="body1">
                  {t.personalInfo.contact.phone}
                </Typography>
              </Box>
            </Box>
            
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <LocationOnIcon 
                color="primary" 
                sx={{ 
                  fontSize: { xs: '1.2rem', sm: '1.4rem' },
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'rotate(10deg) scale(1.1)',
                  },
                }} 
              />
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  {t.contact.info.location}
                </Typography>
                <Typography variant="body1">
                  {t.personalInfo.contact.location}
                </Typography>
              </Box>
            </Box>
            
            <Box sx={{ mt: 4, p: 2, borderRadius: 1, textAlign: 'center' }}>
              <Typography 
                variant="body1"
                color="primary"
                sx={{
                  fontWeight: 600,
                }}
              >
                <i>{t.contact.info.availability}</i>
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Contact;
